import React from "react";
import OlivelaLogo from "../OlivelaLogo";
import PaymentLogos from "./PaymentLogos";

import styles from "../../common/CopyRight/copyRight.module.scss";

export default function CopyRight() {
  const getYear = () => {
    return new Date().getFullYear();
  };

  return (
    <div className={styles.wrapper}>
      <div className="row">
        <div className="grid-md-6 grid-sm-4 d-xs-none">
          <OlivelaLogo className={styles.logo} isSuperbrandHeroPresent={false} />
        </div>
        <PaymentLogos />
      </div>
      <div className="d-md-none">
        <div className={styles.mobile_logo}>
          <OlivelaLogo className={styles.logo} isSuperbrandHeroPresent={false}/>
        </div>
      </div>
      <p className={`x-small-md xx-small-sm xx-small-xs bold ${styles.main}`}>
        &copy; {getYear()} Olivela. All Rights Reserved.
      </p>
      <p className={`xx-small-md xx-small-sm xx-small-xs`}>
        Olivela Inc is a subsidiary of Schoola Inc and the two entities have a
        commercial relationship.
      </p>
      <p className={`xx-small-md xx-small-sm xx-small-xs ${styles.forter_webid}`}>
      Web Id: <span id="token"></span>
      </p>
    </div>
  );
}
